import { Component } from "react";
import "./css/Common.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import LeftMenu from "./components/menu/LeftMenu";
import TopMenu from "./components/menu/TopMenu";
import {
  showAlert,
  removeLoader,
  showLoader,
  DKButton,
} from "deskera-ui-library";
import UserManager from "./managers/UserManager";
import IAM from "./services/iam";
import MixPanelManager from "./managers/common/MIxpanelManger";
import RouteManager, { PAGE_ROUTES } from "./managers/RouteManager";
import InitialApiManager from "./managers/InitialApiManager";
import Empty from "./components/common/Empty";
import AppManager from "./managers/AppManager";
import ApiManager from "./managers/ApiManager";
import Tenant from "./services/tenant";
import TenantManager from "./managers/TenantManager";
import DomainManager from "./managers/DomainManager";
import Table from "./services/table";
import { ADMIN, CONTRACTOR, EMPLOYEE, EMPLOYEE_HIRING_ADMIN, OWNER_ADMIN, OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN, OWNER_ADMIN_HIRING_ADMIN, OWNER_ADMIN_MANAGER, ROUTES } from "./managers/common/RouteAuth";
import { TENANT, TenantService } from "./managers/TenantManagerService";
import ApiConstants from "./constants/ApiConstants";
import { LeftMenuUpdate } from "./components/menu/LeftMenuService";
import { isMobileWebView } from "./utility/ViewportSizeUtils";

import Utility, { deepClone, isMacintosh } from "./utility/Utility";
import { Countries } from "./constants/CountryConstant";
import CompanyDetailService from "./services/CompanyDetailService";
import AutomationService from "./services/automation";
import UserService from "./services/UserService";
import TagManager from 'react-gtm-module'
import { HIDE_CHAT_BUBBLE_CLASS, LANGUAGES_CODE } from "./constants/Constant"
import i18n, { getDefaultLangCode } from "./i18n/i18n";
import UserPermissionService from "./components/user-permissions/UserPermissionService";
import PermissionUtils, { ACTION } from "./components/user-permissions/PermissionUtils";
import ErrorBoundary from "./components/error-boundry/ErrorBoundry";
import InactivityTimer from "./components/idle-timer/InactivityTimer";
import TimeoutManager from "./managers/TimeoutManager";
import { connect } from "react-redux";
import { fetchModuleAccessControl } from "./Redux/Slices/ModuleAccessControlSlice";
import { getRestrictedRoutes } from "./components/module-access-control/ModuleAccessControlConstants";
import RootInterceptor from "./components/RootInterceptor";
import { RootInterceptorObservable } from "./services/RootInterceptorService";
import { fetchAddEmployeeConfig, fetchFieldPermissions, fetchRolePermissions } from "./Redux/Slices/EmployeeListSlice";
import EmployeeConfigService from "./services/EmployeeConfigService";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_TOKEN,
}
TagManager.initialize(tagManagerArgs); 

class App extends Component {
  constructor(props) {
    super(props);
    if (!isMobileWebView()) {
        this.load_cookie_pref();
    }
    this.state = {
      didInitialApiResponseReceived: false,
      isOrgAvailable: null,
      path: window.location.pathname,
      needLogger: false,
      isOrgSetupCompleted: false,
      isAdmin: false,
      activeRoutes: [],
      defaultLangCode: LANGUAGES_CODE.ENGLISH_US,
      timeoutData: null,
      restrictedRoutes: []
    };
  }

  load_cookie_pref() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://tracker.deskera.com/cookie-consent.min.js";
    document.head.appendChild(script);

    script.onload = () => {
      let script_custom = document.createElement("script");
      script_custom.textContent = 'cookieconsent.run({ notice_banner_type: "simple", consent_type: "express",palette: "light",language: "en", cookies_policy_url: "https://www.deskera.com/cookie-policy"});'
      document.head.appendChild(script_custom);
    };
  }



  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  componentDidMount() {
    var pushState = window.history.pushState;
    window.history.pushState = function (state) {
      this.setState({
        path: window.location.pathname,
      });
      return pushState.apply(window.history, arguments);
    }.bind(this);

    if (AppManager.isPublicURL()) {
      this.setState({
        didInitialApiResponseReceived: true,
      });
    } else {
      showLoader();
    }
    if (isMobileWebView()) {
      document.body.classList.add(HIDE_CHAT_BUBBLE_CLASS);
    }

    LeftMenuUpdate.getMessage().subscribe((message)=>{
      this.setState({
        restrictedRoutes: getRestrictedRoutes(this.props.moduleAccessControl)
      }, () => {
        this.setState({
          activeRoutes: this.getActiveRoutes(TenantService.get(TENANT.IS_ADMIN), TenantService.get(TENANT.COUNTRY_CODE))
        });
      });
    });

    RootInterceptorObservable.getMessage().subscribe((message) => {
      if (message.evaluated) {
        this.callInitialApis();
      }
    });
  }

  async getAndSetModuleAccessData() {
    try {
      await this.props.fetchModuleAccessControl();
      if (Array.isArray(this.props?.moduleAccessControl)) {
        this.setState({
          restrictedRoutes: getRestrictedRoutes(this.props.moduleAccessControl)
        });
      }
    } catch(error) {}
  }

  async getEmployeeFieldConfig() {
    const requests = [this.props.fetchAddEmployeeConfig()]
    if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
      requests.push(this.props.fetchFieldPermissions());
      requests.push(this.props.fetchRolePermissions());
    }

    await Promise.all(requests);
    EmployeeConfigService.setEmployeeConfig(this.props.addEmployeeConfig);

    if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
      EmployeeConfigService.setFieldPermissions(this.props.fieldPermissions);
      PermissionUtils.setRolePermissionData(this.props.rolePermissions);
    }
  }


  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

    callInitialApis() {
        ApiManager.checkIfUserLoggedIn(
            () => {
                const userDetails = UserManager.getUserDetails();
                UserService.setUserNameAndEmail(UserManager.getUserID());

                // Trial not allowed
                // InitialApiManager.getPeopleSubscription().then(
                //     (subscription) => {
                //         /***Check if subscribed and then do not call trail API again */
                //         if (subscription && !subscription.Subscribed && !subscription.TrialOver && (!userDetails.emailVerified || !userDetails.isOrgSet)) {
                //             InitialApiManager.SubscribeTrailPlan();
                //         }
                //     }
                // );

                InitialApiManager.getTableDataInit().then(
                    (data) => {
                          Tenant.setRolesDataForExpense();
                          Tenant.getTenantDetails().then((tenant) => {
                            TenantService.getUserData().then( 
                              async() => {
                              TenantManager.setTenantDeatils(tenant);
                              try{
                                const roles = await UserPermissionService.getUserRole(TenantService.get(TENANT.USER_ID))
                                if (roles?.status === "OK") {
                                    PermissionUtils.setUserRole(roles.userRole);
                                }

                                this.getAndSetModuleAccessData();
                                await this.getEmployeeFieldConfig();
                              } catch(e) {}
                              Table.getTenantData().then((peopleTenant) => {
                                TenantService.set(TENANT.OWNER_ID, peopleTenant?.tenant?.iamUserId);
                                const countryCode = peopleTenant['tenant']['countryCode'] || peopleTenant['tenant']['address']['country'];
                                const isAdmin = TenantService.get(TENANT.IS_ADMIN);
                                this.redirectTo(isAdmin, countryCode, peopleTenant['tenant']['orgSetupCompleted']);
                                AutomationService.getAllConnections();
                                TenantService.setTenantData(peopleTenant);
                                InitialApiManager.getSubscription().then(
                                    (res)=>{
                                      if(res && res.ERPPlan && res.ERPPlan.Name && res.ERPPlan.Name !="") {
                                        const planNameERP = res.ERPPlan.Name ? res.ERPPlan.Name : "";
                                        if (planNameERP && planNameERP != "") {
                                          TenantService.set(TENANT.ERP_INTEGATION_SETTING,true)
                                          LeftMenuUpdate.sendMessage(true)
                                        }
                                      } else if (res && res.AIOPlan) {
                                        const planNameAIO = res.AIOPlan.Name ? res.AIOPlan.Name : "";
                                        if (planNameAIO && planNameAIO != "") {
                                          TenantService.set(TENANT.ERP_INTEGATION_SETTING,true)
                                          LeftMenuUpdate.sendMessage(true)
                                        }
                                      }
                                    }, (error) => {
                                          console.log(error)
                                    }
                                );

                                setTimeout(async () => {
                                    if (!peopleTenant['tenant']['orgSetupCompleted'] && !Utility.isEmpty(tenant.country)) {
                                        this.setupTenantCountry(isAdmin, peopleTenant['tenant'], tenant.country);
                                    } else {
                                        const defaultLangCode = getDefaultLangCode(countryCode);
                                        i18n.changeLanguage(defaultLangCode);

                                        this.setState({
                                            isAdmin: isAdmin,
                                            activeRoutes: this.getActiveRoutes(isAdmin, countryCode),
                                            didInitialApiResponseReceived: true,
                                            isOrgSetupCompleted: peopleTenant['tenant']['orgSetupCompleted'],
                                            defaultLangCode: defaultLangCode
                                        }, this.onInitialApiResponseReceived);
                                    }

                                    DomainManager.getAllCustomDomainsFromAPI();
                                    removeLoader();
                                }, 100);
                            });

                            }, (error) => {
                                switch (error.status) {
                                    case "UNAUTHENTICATED":
                                        this.showUnauthorizedPopup();
                                        break;
                                    case "FAILED":
                                        if (!Utility.isEmpty(error.errors) && error.errors[0]?.code === "UM_1003") {
                                            this.showUnauthorizedPopup();
                                        } else {
                                            showAlert("Problem While Loading!", "Unable to load view information. Please try again!");
                                        }
                                        break;
                                    default:
                                        showAlert("Problem While Loading!", "Unable to load view information. Please try again!");
                                        break;
                                }
                            }
                        );
                    }
                );
            }, (err) => {
                    showAlert(
                        "Problem While Loading!",
                        "Unable to load view information. Please try again!"
                    );
                    removeLoader();
                });
            },
            () => { }
        );
    }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  initialAPIReceived = (err) => {
    if (
      UserManager.getUserDetails() &&
      !UserManager.getUserDetails().emailVerified
    ) {
      this.showEmailVerificationPopup();
    }
    this.setState({
      isOrgAvailable: true,
      didInitialApiResponseReceived: true,
    });

    removeLoader();
    MixPanelManager.init();
    MixPanelManager.openGO();
  };

  initialAPIFailed = (err = null) => {
    removeLoader();
    if (err && err.errorMessage === "Org not set") {
      this.setState({
        isOrgAvailable: false,
      });
    } else {
      showAlert("Error!", "Server error occurred.");
    }
  };

  onInitialApiResponseReceived() {
    TimeoutManager.getIdleTimeoutTokenExpiry().then(
      (response) => {
        if (response.id) {
          TimeoutManager.setTimeoutData(response);
        } else {
          // set default data
          TimeoutManager.setTimeoutData(TimeoutManager.TIMEOUT_DATA);
        }
      }, (error) => {
        console.log(error);
        // set default data
        TimeoutManager.setTimeoutData(TimeoutManager.TIMEOUT_DATA);
      },
    ).finally(() => {
      this.setState({
        timeoutData: TimeoutManager.getTimeoutData()
      });
    });
  }

  getActiveRoutes(isAdmin, countryCode) {
		const isOwner = TenantService.get(TENANT.IS_OWNER);
		const isHiringAdmin = TenantService.get(TENANT.IS_HIRING_ADMIN);
		const isContractor = TenantService.get(TENANT.IS_CONTRACTOR);
		const environment = ApiConstants.CURRENT_ENVIRONMENT;

		const ACTIONS = [ACTION.VIEW, ACTION.CREATE, ACTION.EDIT, ACTION.DELETE, ACTION.EXPORT, ACTION.IMPORT, ACTION.SUBMIT];

		return ROUTES.filter((route) => {
			const countryCheck = route.country.includes('-1') || route.country.includes(countryCode);
			if (!countryCheck) {
				return false;
			}

			const environmentCheck = route.environment === undefined || route.environment.includes(environment) || route.environment.includes('-1');
			if (!environmentCheck) {
				return false;
			}

			const isRestrictedRoute = this.state.restrictedRoutes.includes(route.route);
			if (isRestrictedRoute) {
				return false;
			}

			const contractorCheck = !isContractor && route.accessTo === OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN;
			if (contractorCheck) {
				return true;
			}

			const hasPermission = PermissionUtils.hasMultiModuleAccess(route.accessToModule, ACTIONS, route.hasEachAccess);			
			const permissionCheck = route.accessToModule && !isOwner && !isHiringAdmin && hasPermission;
			if (permissionCheck) {
				return true;
			}

			if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
				return hasPermission || PermissionUtils.hasAccessPermissisonForPWUsers(null, route);
			}

			let hasRoleAccess = false;
			if (isOwner || isAdmin) {
				hasRoleAccess =
					route.accessTo === OWNER_ADMIN ||
					route.accessTo === OWNER_ADMIN_HIRING_ADMIN ||
					route.accessTo === OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN ||
					route.accessTo === OWNER_ADMIN_MANAGER;
			} else if (isHiringAdmin) {
				hasRoleAccess = route.accessTo === OWNER_ADMIN_HIRING_ADMIN || route.accessTo === EMPLOYEE_HIRING_ADMIN;
			} else if (isContractor) {
				hasRoleAccess = route.accessTo === CONTRACTOR;
			} else {
				hasRoleAccess = route.accessTo === EMPLOYEE_HIRING_ADMIN;
			}

			return hasRoleAccess;
		});
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    if (window.location.hash.startsWith("#/")) {
      window.location = window.location.hash.replace("#", "");
    }

    return (
        <>
            {this.state.didInitialApiResponseReceived && this.state.timeoutData &&
                <InactivityTimer
                    name={ApiConstants.IDLE_TIMER_ID}
                    inactivityTimeoutEnabled={this.state.timeoutData.idleTimeoutEnabled}
                    inactivityTimeout={this.state.timeoutData.idleTimeoutValue}
                    tokenExpiryNotifyEnabled={this.state.timeoutData.tokenExpiryEnabled}
                    tokenExpiryTime={this.state.timeoutData.tokenExpiryTime}
                    autoLogoutTime={ApiConstants.AUTO_LOGOUT_TIME}
                    refreshTokenUrl={ApiConstants.URL.BASE + ApiConstants.URL.IAM.REFRESH_TOKEN}
                    logoutUrl={ApiConstants.URL.BASE + ApiConstants.URL.IAM.LOG_OUT}
                    redirectUrl={ApiConstants.URL.IAM.REDIRECT}
                />
            }
            <Router>
                <div className="screen-height bg-gray1 row align-items-start app-font " style={{position:"fixed"}}>
                    {/* Root Interceptor */}
                    <Switch>
                        <Route path="/" render={(props) => <RootInterceptor {...props} />} />
                    </Switch>
                    {/* END - Root Interceptor */}

                    {/* LEFT MENU */}
                    <Switch>
                        <Route exact path={PAGE_ROUTES.PUBLIC_PAGE} component={Empty} />
                        {this.state.didInitialApiResponseReceived && (
                            <Route path="/" render={(props) => <LeftMenu accessedBy={this.state.isAdmin ? ADMIN : EMPLOYEE} {...props} />} />
                        )}
                    </Switch>
                    {/* END - LEFT MENU */}

                    <div
                        className=" parent-height column parent-width "
                        style={{ flex: 1, backgroundColor: "rgb(235, 239, 243)" }}
                    >
                        {/* TOP MENU */}
                        <Switch>
                            <Route exact path={PAGE_ROUTES.PUBLIC_PAGE} component={Empty} />
                            {this.state.didInitialApiResponseReceived && (
                                <Route path="/" render={(props) => <TopMenu accessedBy={this.state.isAdmin ? ADMIN : EMPLOYEE} {...props} isOrgSetupCompleted={this.state.isOrgSetupCompleted} defaultLangCode={this.state.defaultLangCode} />} />
                            )}
                        </Switch>
                        {/* END - TOP MENU */}

                        {this.state.didInitialApiResponseReceived && (
                          <ErrorBoundary>
                            <div
                                id="containerDiv"
                                className={
                                    "parent-width column position-relative" +
                                    (AppManager.isPublicURL() ? "" : " main-holder-padding ") +
                                    (isMacintosh() ? "" : " show-scroll-bar")
                                }
                                style={{ overflowY: "auto", flexGrow: 1, paddingBottom: 60 }}
                            >
                                <Switch>
                                    {this.state.activeRoutes.map((r) => {
                                        return (
                                            <Route
                                                exact
                                                path={r.route}
                                                render={(props) => r.render({ accessedBy: this.state.isAdmin ? ADMIN : EMPLOYEE, ...props })}
                                            />
                                        )
                                    })}

                                    <Route
                                        path="*"
                                        render={(props) => {
                                            RouteManager.setPresenter({ props });
                                            RouteManager.navigateToHome();
                                        }}
                                    />
                                </Switch>
                            </div>
                          </ErrorBoundary>
                        )}
                    </div>
                </div>
            </Router>
        </>
    );
  }
  getLogger() {
    return (
      <div
        className="position-absolute border-radius-m"
        style={{ bottom: 20, right: 20, backgroundColor: "black" }}
      >
        <DKButton
          title="Logger"
          className="fw-m text-white"
          onClick={() => {
            this.setState({ needLogger: true });
          }}
        />
      </div>
    );
  }
  showEmailVerificationPopup = () => {
    showAlert(
      `Verify your email address`,
      `We have sent an email to <b>${UserManager.getUserEmail()}</b>, If you don't see it, please check your spam folder`,
      [
        {
          title: "Do it later",
          className: "bg-gray1  border-m mt-r",
        },
        {
          title: "Resend email",
          onClick: () => this.resendVerificationEmail(),
          className: "bg-app  text-white ml-r mt-r",
        },
      ]
    );
  };
  resendVerificationEmail = () => {
    IAM.resendVerificationEmail().then(
      (data) => { },
      (err) => { }
    );
  };

  redirectTo(isAdmin, countryCode, orgSetupCompleted) {
    if (ApiConstants.EMPLOYEE_LOGIN_REDIRECT && !isAdmin) {
        window.location.replace(ApiConstants.PRODUCT_URL_PEOPLE);
        return;
    }

    // if (ApiConstants.COMPLIANCE_COUNTRY.split(";").indexOf(countryCode) === -1 && orgSetupCompleted) {
    //     window.location.replace(ApiConstants.PRODUCT_URL_PEOPLE);
    //     return;
    // }
    // if (countryCode && ApiConstants.COMPLIANCE_COUNTRY.split(";").indexOf(countryCode) === -1 && !orgSetupCompleted) {
    //   window.location.replace(ApiConstants.PRODUCT_URL_PEOPLE);
    //   return;
    // }
  }

    getSubscription(trial) {
        if (trial) {
            showAlert(
                `<div class="fs-l">Start Trial</div>`,
                `<div class="fw-m fs-l mb-s">You do not have any active plan!</div>
                <div>Click below to start trial and continue using the product.</div>`,
                [
                    {
                        title: "Ok",
                        className: "bg-app text-white",
                        onClick: () => {
                            window.location.replace(ApiConstants.TALK_TO_SALES_URL);
                        }
                    }
                ]
            );
        } else {
            showAlert(
                `<div class="fs-l">Trial Expired</div>`,
                `<div class="fw-m fs-l mb-s">Your trial period has expired!</div>
                <div>Click below to purchase a plan and continue using the product.</div>`,
                [
                    {
                        title: "Ok",
                        className: "bg-app text-white",
                        onClick: () => {
                            window.location.replace(ApiConstants.PRODUCT_URL_GO + "billing");
                        }
                    }
                ]
            );
        }
    }
    showUnauthorizedPopup() {
      showAlert(
          "Not Authorized",
          "You are not authorized to access this application. Please contact your organisation Admin.",
          [
              {
                  title: "Ok",
                  className: "bg-app text-white",
                  onClick: () => {
                      window.location.replace(ApiConstants.PRODUCT_URL_GO);
                  }
              }
          ]
      );
  }

    verifyEmail(userDetails) {
        const URL = ApiConstants.AUTH_BASE_URL + ApiConstants.URL.AUTH.VERIFY_EMAIL + `?mode=EMAILNOTVERIFIED&email=${userDetails.email}&name=&verified=false`;
        window.open(URL, "_self");
    }

    setupTenantCountry(isAdmin, tenant, country) {
        const countryObj = Countries.find((c) => c.value === country);
        if(!countryObj) { // this check handle for non IN/US country
          this.redirectTo(isAdmin, country, tenant['orgSetupCompleted'])
        } else {
          const params = CompanyDetailService.getTenantSetupParams(deepClone(tenant), countryObj);
          CompanyDetailService.updateCompanyDetail(params).then(
            (response) => {
              if (response && response.status === "OK") {
                TenantManager.setPeopleTenantData(response);
                TenantService.set(TENANT.COUNTRY_CODE, countryObj?.value);
                TenantService.set(TENANT.CURRENCY_CODE, countryObj?.currencyCode);
                TenantService.set(TENANT.ADDRESS, response['tenant']['address']);
                TenantService.set(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED,response['tenant']['isAttendanceAttachmentsEnabled']);
                const defaultLangCode = getDefaultLangCode(countryObj?.value);
                i18n.changeLanguage(defaultLangCode);

                this.setState({
                    isAdmin: isAdmin,
                    activeRoutes: this.getActiveRoutes(isAdmin, country),
                    didInitialApiResponseReceived: true,
                    isOrgSetupCompleted: response['tenant']['orgSetupCompleted'],
                    defaultLangCode: defaultLangCode
                }, this.onInitialApiResponseReceived);
              }
            }, (error) => {
              const defaultLangCode = getDefaultLangCode(null);
              i18n.changeLanguage(defaultLangCode);

              this.setState({
                isAdmin: isAdmin,
                activeRoutes: this.getActiveRoutes(isAdmin, "-1"),
                didInitialApiResponseReceived: true,
                isOrgSetupCompleted: tenant['tenant']['orgSetupCompleted'],
                defaultLangCode: defaultLangCode
              }, this.onInitialApiResponseReceived);
            }
          );
        }
    }
}

const mapStateToProps = (state) => ({
	moduleAccessControl: state.moduleAccessControl?.data,
  addEmployeeConfig: state.employee?.fieldConfig?.fieldConfigs || [],
  fieldPermissions: state.employee?.fieldPermissions?.resp || [],
  rolePermissions: state.employee?.rolePermissions || []
});

const mapDispatchToProps = (dispatch) => ({
  fetchModuleAccessControl: () => dispatch(fetchModuleAccessControl()),
  fetchAddEmployeeConfig: () => dispatch(fetchAddEmployeeConfig()),
  fetchFieldPermissions: () => dispatch(fetchFieldPermissions()),
  fetchRolePermissions: () => dispatch(fetchRolePermissions())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
